import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type AuditState = CommonTableState;

const initialState: AuditState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "timestamp", desc: true }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnOrder: ["auditor", "entityId", "entityClassName", "timestamp", "changedColumns", "operationType"],
        density: "compact",
    },
};

export const auditSlice = createSlice({
    name: "audit",
    initialState: initialState,
    reducers: {
        updateAuditTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const { updateAuditTableState } = auditSlice.actions;

export default auditSlice.reducer;
